export default {
  title: 'Galerie',
  sections: {
    logo: 'Logo',
    web_images: 'Imagini galerie comandă online',
  },
  toasts: {
    image_uploaded: 'Modificările au fost salvate cu succes',
    image_upload_failed: 'Salvarea modificărilor a eșuat',
  },
};
